import {
  identifyIdin as identifyIdinUser,
  verifyIdin as verifyIdinUser
} from '../api/idin'
import { setIdinResultStatus } from '../state/slices/idin_slice'
import { logEvent } from '../utils/firebase'
import { useAppDispatch } from './state'

export const useIdin = () => {
  const dispatch = useAppDispatch()

  const identifyIdin = async (redirectUrl: string, email: string) => {
    const { data } = await identifyIdinUser(redirectUrl, email)

    dispatch(setIdinResultStatus(undefined))

    return data
  }

  const verifyIdin = async (
    entranceCode: string,
    transactionId: string,
    registerUrl: string,
    email: string
  ) => {
    try {
      const { data } = await verifyIdinUser(
        entranceCode,
        transactionId,
        registerUrl,
        email
      )

      dispatch(setIdinResultStatus('SUCCESS'))
      logEvent('idin_success')

      logEvent('idin_error')

      return data
    } catch (error) {
      dispatch(setIdinResultStatus('ERROR'))
    }
  }

  return {
    identifyIdin,
    verifyIdin
  }
}

export default useIdin
